export const DARKTHEME = 'dark-theme';
export const TOOLBAR =
    'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat';
export const PLUGINS = 'lists link image table code help';
export const SKINURL = '/assets/WYSIWYG-skin-url/skins/ui/CUSTOM';
export const DISABLECONTEXTMENU = 'disable';
export const FONTFAMILYFORMATS =
    'Arial=arial, helvetica, sans-serif; Courier New=courier new, courier, monospace; Georgia=georgia, palatino, serif; Lato=lato, sans-serif Roboto=roboto, sans-serif; sans-serif; Times New Roman=times new roman,times,serif;';
